import { motion } from "framer-motion";

const KolektifAvrupa = () => {
  return (
    <main className="min-h-screen bg-gradient-to-b from-[#0A0A0A] via-[#111111] to-[#0A0A0A]">
      <div className="absolute inset-0 bg-[url('/noise.png')] opacity-5 pointer-events-none"></div>

      {/* Hero Section */}
      <div className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/50 to-[#0A0A0A] z-10" />
        </div>

        <div className="relative z-20 text-center px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6">
              Kolektif Avrupa
            </h1>
            <p className="text-xl sm:text-2xl text-blue-300 max-w-3xl mx-auto">
              Avrupa'daki Türk öğrencilerin güçlü ağı
            </p>
          </motion.div>
        </div>
      </div>

      {/* Content Section */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="space-y-8"
          >
            <div>
              <h2 className="text-2xl font-bold text-white mb-4">Biz Kimiz?</h2>
              <p className="text-gray-300 leading-relaxed">
                Kolektif Avrupa, Kolektif Oluşum'un Avrupa'daki
                temsilciliklerini ve faaliyetlerini yöneten birimdir.
                Avrupa'daki gençlerin bir araya gelmesini, bilgi ve deneyim
                paylaşımını sağlayan bir platform olarak hizmet vermektedir.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4">
                Ne Yapıyoruz?
              </h2>
              <p className="text-gray-300 leading-relaxed">
                Avrupa'daki üniversitelerde okuyan öğrencilerin bir araya
                gelmesini sağlayan Kolektif Avrupa, gençlerin kariyer
                gelişimlerine katkıda bulunmakta ve onları geleceğe
                hazırlamaktadır.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors duration-300">
              <h3 className="text-xl font-semibold text-white mb-3">
                Uluslararası Etkinlikler
              </h3>
              <p className="text-gray-400">
                Avrupa'nın farklı şehirlerinde düzenlediğimiz etkinliklerle
                öğrencileri bir araya getiriyor, kültürler arası etkileşimi
                artırıyoruz.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors duration-300">
              <h3 className="text-xl font-semibold text-white mb-3">
                Akademik Destek
              </h3>
              <p className="text-gray-400">
                Avrupa'da eğitim almak isteyen öğrencilere rehberlik ediyor,
                başvuru süreçlerinde destek oluyoruz.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors duration-300">
              <h3 className="text-xl font-semibold text-white mb-3">
                Global Kariyer Fırsatları
              </h3>
              <p className="text-gray-400">
                Uluslararası şirketlerle iş birliği yaparak öğrencilerimize
                global kariyer fırsatları sunuyoruz.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </main>
  );
};

export default KolektifAvrupa;
